module.exports = __webpack_public_path__ + "static/img/bg-1.5cb877a9.png";